import React from 'react';

interface QuickQuestionButtonProps {
  question: string;
  onQuestionClick: (question: string) => void;
}

const QuickQuestionButton: React.FC<QuickQuestionButtonProps> = ({
  question,
  onQuestionClick,
}) => {
  return (
    <button
      onClick={() => onQuestionClick(question)}
      className="px-4 py-3 bg-white border border-gray-300 rounded-lg shadow-sm hover:shadow-md hover:border-blue-400 transition-all duration-200 text-left text-gray-700 hover:text-blue-600"
    >
      <span className="text-sm">{question}</span>
    </button>
  );
};

export default QuickQuestionButton;

